import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { QrCode } from "lucide-react";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
      "with search params:",
      location.search
    );
  }, [location.pathname, location.search]);

  const isMenuError = location.pathname === "/menu";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="text-center p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-md">
        {isMenuError ? (
          <QrCode className="mx-auto h-12 w-12 text-red-500 opacity-70 mb-2" />
        ) : (
          <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">
            {t("notFound")}
          </h1>
        )}

        <p className="text-xl text-gray-600 dark:text-gray-300 mb-4">
          {isMenuError ? t("menuAccessError") : t("oopsPageNotFound")}
        </p>

        <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
          {isMenuError
            ? t("unableToAccessMenu", { searchParams: location.search })
            : t("requestedPathNotFound", {
                pathname: location.pathname,
                searchParams: location.search,
              })}
        </p>

        <a
          href="/"
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
        >
          {t("returnToHome")}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
